var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfosetsMoreListMembersMenu',{attrs:{"infosetId":_vm.infosetId,"moreMembers":_vm.moreMembers},on:{"removeMember":_vm.removeMember}})}
var staticRenderFns = []

export { render, staticRenderFns }